{
  "welcome": "Witamy w",
  "instructions": "Naciśnij poniżej, aby rozpocząć proces zameldowania.",
  "startCheckIn": "Rozpocznij zameldowanie",
  "missingWarehouseTitle": "Brak magazynu",
  "missingWarehouseMessage": "Link jest nieprawidłowy, musi zawierać ID magazynu",
  "recaptchaAttribution": "Ta strona jest chroniona przez reCAPTCHA i obowiązują {privacyPolicy} oraz {termsOfService} Google.",
  "recaptchaPrivacyPolicy": "Polityka prywatności",
  "recaptchaTermsOfService": "Warunki korzystania z usługi",
  "lookupTitle": "Dodaj numer referencyjny lub numer potwierdzenia, aby znaleźć swoją wizytę",
  "referenceNumberLabel": "Numer referencyjny lub numer potwierdzenia",
  "referenceNotFoundError": "Numer referencyjny lub numer potwierdzenia nie pasuje do żadnej ważnej wizyty.",
  "checkIn": "Zamelduj się",
  "loadTypeLabel": "Typ ładunku",
  "directionLabel": "Kierunek",
  "operationLabel": "Operacja",
  "dockLabel": "Dok",
  "orDivider": "lub",
  "noReferenceTitle": "Nie mam numeru potwierdzenia",
  "noReferenceDescription": "Kontynuuj bez wizyty, korzystając ze standardowego procesu zameldowania.",
  "checkInWithoutAppointment": "Zamelduj się bez wizyty",
  "readyToCheckInTitle": "Gotowy do odprawy?",
  "readyToCheckInDescription": "Dotknij poniżej, aby rozpocząć. Swoje dane wprowadzisz na następnym ekranie.",
  "referenceRequiredHint": "Do odprawy w tej lokalizacji wymagany jest numer referencyjny.",
  "haveAppointment": "Mam wizytę",
  "direction": {
    "inbound": "Przychodzące",
    "outbound": "Wychodzące",
    "inOut": "Przychodzące i wychodzące",
    "load": "Załadunek",
    "unload": "Rozładunek"
  },
  "operation": {
    "live": "Na żywo",
    "drop": "Pozostawienie",
    "other": "Inna"
  }
}
